module.exports = __webpack_public_path__ + "img/hn.b2b088b9.svg";